import React from "react";
import { Col, Container, Row, Tab, Nav } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import "../style/services-usa/shopify-web-development/_provenTechniques.scss";
import { Link } from "gatsby";

function ProvenTechniques() {
  return (
    <section className="redefinepatient_services tekgrip_section proven-techniques p-100 overflow-x-hidden">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              Achieve More with a{" "}
              <span>Reliable Construction Software Development </span>
              Company
            </h2>
          </Col>
        </Row>
        <Row className="mt-lg-5 mt-md-3 md-sm-2">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="tekgrip_tabs"
          >
            <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
              <Tab.Container id="" defaultActiveKey="0">
                <Row>
                  <Col xs={12} md={12} lg={12} xl={6} className="redefine_tabs">
                    <Nav variant="pills" className="flex-column">
                      <div className="red_item">
                        <Nav.Item>
                          <Nav.Link eventKey="0">
                            <span>01.</span> Streamlined Workflows
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="1">
                            <span>02.</span> Long-term Cost Savings
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="2">
                            <span>03.</span> Improved Decision-making
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="3">
                            <span>04.</span> On-time Project Delivery
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="4">
                            <span>05.</span> Regulatory Compliance
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="5">
                            <span>06.</span> Effective Resource Management
                          </Nav.Link>
                        </Nav.Item>
                      </div>
                    </Nav>
                  </Col>
                  <Col xs={12} md={12} lg={12} xl={6} className="p-0">
                    <Tab.Content style={{ background: "#F9F9F9" }}>
                      <Tab.Pane eventKey="0">
                        <div className="content-wrap">
                          <div className="content">
                            <h3 style={{ color: "#f47a14" }}>
                              Streamlined Workflows
                            </h3>
                            <p>
                              Custom software helps you automate repetitive
                              tasks and optimize the flow of information,
                              ensuring better project management and
                              productivity from start to finish.
                            </p>
                            {/* <Link
                              style={{ background: "#f47a14", color: "#fff" }}
                              to="/contact"
                              className="border_btn"
                              aria-label="TekRevol Contact"
                            >
                              Discuss Your AI Solution
                            </Link> */}
                          </div>
                          <div className="image">
                            <StaticImage
                              src="../../images/services-usa/construction-software/tab-1.webp"
                              alt="Intuitive Navigation"
                              className="img-fluid mw-100"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={316}
                              height={499}
                            />
                          </div>
                        </div>
                      </Tab.Pane>
                      <Tab.Pane eventKey="1">
                        <div className="content-wrap">
                          <div className="content">
                            <h3 style={{ color: "#f47a14" }}>
                              Long-term Cost Savings
                            </h3>
                            <p>
                              Streamlined operations and resource management cut
                              down cost overhead, preventing budget overruns at
                              your projects and maximizing overall
                              profitability.
                            </p>
                            {/* <Link
                              style={{ background: "#f47a14", color: "#fff" }}
                              to="/contact"
                              className="border_btn"
                              aria-label="TekRevol Contact"
                            >
                              Discuss Your AI Solution
                            </Link> */}
                          </div>
                          <div className="image">
                            <StaticImage
                              src="../../images/services-usa/construction-software/tab-2.webp"
                              alt="Intuitive Navigation"
                              className="img-fluid mw-100"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={316}
                              height={499}
                            />
                          </div>
                        </div>
                      </Tab.Pane>
                      <Tab.Pane eventKey="2">
                        <div className="content-wrap">
                          <div className="content">
                            <h3 style={{ color: "#f47a14" }}>
                              Improved Decision-making
                            </h3>
                            <p>
                              Construction software developed at Tekrevol
                              enables business owners to access real-time data
                              and make informed decisions that reduce risks and
                              boost project success.
                            </p>
                            {/* <Link
                              style={{ background: "#f47a14", color: "#fff" }}
                              to="/contact"
                              className="border_btn"
                              aria-label="TekRevol Contact"
                            >
                              Discuss Your AI Solution
                            </Link> */}
                          </div>
                          <div className="image">
                            <StaticImage
                              src="../../images/services-usa/construction-software/tab-3.webp"
                              alt="Intuitive Navigation"
                              className="img-fluid mw-100"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={316}
                              height={499}
                            />
                          </div>
                        </div>
                      </Tab.Pane>
                      <Tab.Pane eventKey="3">
                        <div className="content-wrap">
                          <div className="content">
                            <h3 style={{ color: "#f47a14" }}>
                              On-time Project Delivery
                            </h3>
                            <p>
                              Project delays are a major headache for
                              construction companies. Proactive project
                              management tools identify potential delays early,
                              allowing for timely interventions.
                            </p>
                            {/* <Link
                              style={{ background: "#f47a14", color: "#fff" }}
                              to="/contact"
                              className="border_btn"
                              aria-label="TekRevol Contact"
                            >
                              Discuss Your AI Solution
                            </Link> */}
                          </div>
                          <div className="image">
                            <StaticImage
                              src="../../images/services-usa/construction-software/tab-4.webp"
                              alt="Intuitive Navigation"
                              className="img-fluid mw-100"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={316}
                              height={499}
                            />
                          </div>
                        </div>
                      </Tab.Pane>
                      <Tab.Pane eventKey="4">
                        <div className="content-wrap">
                          <div className="content">
                            <h3 style={{ color: "#f47a14" }}>
                              Regulatory Compliance
                            </h3>
                            <p>
                              Staying compliant with construction codes and
                              regulations protects your business from costly
                              fines and legal risks and enhances your company's
                              overall reputation.
                            </p>
                            {/* <Link
                              style={{ background: "#f47a14", color: "#fff" }}
                              to="/contact"
                              className="border_btn"
                              aria-label="TekRevol Contact"
                            >
                              Discuss Your AI Solution
                            </Link> */}
                          </div>
                          <div className="image">
                            <StaticImage
                              src="../../images/services-usa/construction-software/tab-5.webp"
                              alt="Intuitive Navigation"
                              className="img-fluid mw-100"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={316}
                              height={499}
                            />
                          </div>
                        </div>
                      </Tab.Pane>
                      <Tab.Pane eventKey="5">
                        <div className="content-wrap">
                          <div className="content">
                            <h3 style={{ color: "#f47a14" }}>
                              Effective Resource Management
                            </h3>
                            <p>
                              Our resource management solutions help you
                              optimize labor, equipment, and materials, ensuring
                              you never run out of crucial resources at any
                              project stage.
                            </p>
                            {/* <Link
                              style={{ background: "#f47a14", color: "#fff" }}
                              to="/contact"
                              className="border_btn"
                              aria-label="TekRevol Contact"
                            >
                              Discuss Your AI Solution
                            </Link> */}
                          </div>
                          <div className="image">
                            <StaticImage
                              src="../../images/services-usa/construction-software/tab-6.webp"
                              alt="Intuitive Navigation"
                              className="img-fluid mw-100"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={316}
                              height={499}
                            />
                          </div>
                        </div>
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </Col>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ProvenTechniques;
